import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFakeFreeConsumerTestFlightOn } from 'owa-proofing-option/lib/utils/isFakeFreeConsumerTestFlightOn';
import { IdentityProvider } from '@nlapps/editor-client-web';

export function getIdentityProvider(): IdentityProvider {
    if (isFakeFreeConsumerTestFlightOn()) {
        return IdentityProvider.MSA;
    }

    return isConsumer() ? IdentityProvider.MSA : IdentityProvider.AAD;
}
